module.exports = __webpack_public_path__ + "static/media/pe-icon-set-weathere60d.ea37c7a8.ttf";